/**
 * @file コンポーネント：フル動画ページ症例データコンテンツメインデータ DOM管理
 */

// ライブラリ読み込み
import React, { Suspense } from "react";

// コンポーネント読み込み
const DigestPlayer = React.lazy(() => import("~/src/components/projects/Video/DigestPlayer").then((module) => ({ default: module.DigestPlayer, })));
import { FullvideoPlayer } from "~/src/components/projects/Video/FullvideoPlayer";
const OperativeInformation = React.lazy(() => import("~/src/components/projects/Video/OperativeInformation").then((module) => ({ default: module.OperativeInformation, })));
const Pointcontents = React.lazy(() => import("~/src/components/projects/Video/Pointcontents").then((module) => ({ default: module.Pointcontents, })));
const Summary = React.lazy(() => import("~/src/components/projects/Video/Summary").then((module) => ({ default: module.Summary, })));

// スタイル読み込み
import { StyledContentlist, StyledContentlistItem } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    return (
        <StyledContentlist>
            {/* 術前情報 */}
            {(props.hasPreoperation === true || props.isEditPage === true) && (
                <StyledContentlistItem
                    className={
                        props.selectedContentsData === "preoperation" &&
                        "is-active"
                    }
                >
                    <OperativeInformation
                        setIsOpenModalLogin={props.setIsOpenModalLogin}
                        fnSetModalEdit={props.fnSetModalEdit}
                        hasDigest={props.hasDigest}
                        isEditPage={props.isEditPage}
                        isPaid={props.isPaid}
                        isPurchased={props.isPurchased}
                        languageCodeOperation={props.languageCodeOperation}
                        setIsHighlightPopupPayment={
                            props.setIsHighlightPopupPayment
                        }
                        setSelectedContentsData={props.setSelectedContentsData}
                        sliders={props.slidersPreoperation}
                        text={props.textPreoperation}
                        type="preoperation"
                    />
                </StyledContentlistItem>
            )}
            {/* フル動画 */}
            <StyledContentlistItem
                className={
                    props.selectedContentsData === "fullvideo" && "is-active"
                }
            >
                <FullvideoPlayer
                    fairplayCer={props.fairplayCer}
                    fairplayLaUrl={props.fairplayLaUrl}
                    fnJump={props.fnJump}
                    hasAudio={props.hasAudio}
                    isEditPage={props.isEditPage}
                    isCompletionMediaPlayerFullvideo={props.isCompletionMediaPlayerFullvideo}
                    isPlay={props.isPlay}
                    isSponsorContent={props.isSponsorContent}
                    languageCodeOperation={props.languageCodeOperation}
                    listComment={props.listComment}
                    listEvent={props.listEvent}
                    listTopic={props.listTopic}
                    mainSurgeonId={props.mainSurgeonId}
                    movieUrl={props.movieUrl}
                    operationId={props.operationId}
                    playreadyLaUrl={props.playreadyLaUrl}
                    refFullvideoPlayerButtonlistSetting={
                        props.refFullvideoPlayerButtonlistSetting
                    }
                    refFullvideoPlayerIconlist={
                        props.refFullvideoPlayerIconlist
                    }
                    refFullvideoPlayerJumpButton={
                        props.refFullvideoPlayerJumpButton
                    }
                    setMediaPlayerFullvideo={props.setMediaPlayerFullvideo}
                    setPlayEvent={props.setPlayEvent}
                    timeProgress={props.timeProgress}
                    timeProgressSecond={props.timeProgressSecond}
                    timeTotalSecond={props.timeTotalSecond}
                    videoPlayRatioType={props.videoPlayRatioType}
                    widevineLaUrl={props.widevineLaUrl}
                />
            </StyledContentlistItem>
            {/* 術後情報 */}
            {(props.hasPostoperation === true || props.isEditPage === true) && (
                <StyledContentlistItem
                    className={
                        props.selectedContentsData === "postoperation" &&
                        "is-active"
                    }
                >
                    {props.isCompletionMediaPlayerFullvideo === true && (
                    <Suspense><OperativeInformation
                        setIsOpenModalLogin={props.setIsOpenModalLogin}
                        fnSetModalEdit={props.fnSetModalEdit}
                        hasDigest={props.hasDigest}
                        isEditPage={props.isEditPage}
                        languageCodeOperation={props.languageCodeOperation}
                        isPaid={props.isPaid}
                        isPurchased={props.isPurchased}
                        setIsHighlightPopupPayment={
                            props.setIsHighlightPopupPayment
                        }
                        setSelectedContentsData={props.setSelectedContentsData}
                        sliders={props.slidersPostoperation}
                        text={props.textPostoperation}
                        type="postoperation"
                    /></Suspense>)}
                </StyledContentlistItem>
            )}
            {/* ダイジェスト動画 */}
            {props.hasDigest === true && (
                <StyledContentlistItem
                    className={
                        props.selectedContentsData === "digestvideo" &&
                        "is-active"
                    }
                >
                {props.isCompletionMediaPlayerFullvideo === true && (
                    <Suspense><DigestPlayer
                        isSponsorContent={props.isSponsorContent}
                        operationId={props.operationId}
                        selectedContentsData={props.selectedContentsData}
                    /></Suspense>)}
                </StyledContentlistItem>
            )}
            {/* ポイントコンテンツ */}
            {props.hasPointcontents === true && (
                <StyledContentlistItem
                    className={
                        props.selectedContentsData === "pointcontents" &&
                        "is-active"
                    }
                >
                    {props.isCompletionMediaPlayerFullvideo === true && (
                    <Suspense><Pointcontents
                        fnJump={props.fnJump}
                        isEditPage={props.isEditPage}
                        isPaid={props.isPaid}
                        isPurchased={props.isPurchased}
                        languageCodeOperation={props.languageCodeOperation}
                        operationId={props.operationId}
                        setIsHighlightPopupPayment={
                            props.setIsHighlightPopupPayment
                        }
                        setSelectedContentsData={props.setSelectedContentsData}
                        setIsOpenModalLogin={props.setIsOpenModalLogin}
                    /></Suspense>)}
                </StyledContentlistItem>
            )}
            {/* 概要 */}
            {(props.isEditPage === true ||
                props.adOperationSummary !== null ||
                props.listSurgicalEquipment.length > 0 ||
                props.summary !== null) && (
                <StyledContentlistItem
                    className={
                        props.selectedContentsData === "summary" && "is-active"
                    }
                >
                    {props.isCompletionMediaPlayerFullvideo === true && (
                    <Suspense><Summary
                        adOperationLink={props.adOperationLink}
                        adOperationSummary={props.adOperationSummary}
                        fnSetModalEdit={props.fnSetModalEdit}
                        isEditPage={props.isEditPage}
                        languageCodeOperation={props.languageCodeOperation}
                        listSurgicalEquipment={props.listSurgicalEquipment}
                        operationId={props.operationId}
                        refSummary={props.refSummary}
                        refTitle={props.refTitle}
                        summary={props.summary}
                    /></Suspense>)}
                </StyledContentlistItem>
            )}
        </StyledContentlist>
    );
};
